import React from "react";
import PropTypes from "prop-types";
import {NameChip, Spinner} from "../../../components";

const usernameOptions = {
  compact: PropTypes.bool, // renders a tooltip of the username instead of the username to the right
  justName: PropTypes.bool,
  loading: PropTypes.bool,
  loadingIndicator: PropTypes.any,
  chipSize: PropTypes.string,
  displayUsername: PropTypes.bool, // display username instead of full name
  tooltip: PropTypes.bool,
};

export class Username extends React.Component {

  static optionsProps = usernameOptions
  static propTypes = {
    user: PropTypes.shape({
      userId: PropTypes.string.isRequired,
      username: PropTypes.string.isRequired,
      firstName: PropTypes.string,
      lastName: PropTypes.string
    }), // a user from the UserResolver
    ...usernameOptions
  }

  static defaultProps = {
    loadingIndicator: <Spinner size="xs" style={{display: 'inline-block'}} />
  }

  render() {
    const {user, compact, justName, displayUsername,
      chipSize, tooltip, loading, loadingIndicator, ...rest} = this.props
    if (loading) {
      return loadingIndicator
    } else {
      const name = displayUsername ? user.username : [user.firstName, user.lastName]
        .filter(x => !!x)
        .map(x => x.trim())
        .filter(x => !!x)
        .join(' ') || user.username

      const nameWithCancellations = user.cancelled === true ? " Cancelled" : name

      return justName
        ? <span {...rest}>{nameWithCancellations}</span>
        : <NameChip colorFrom={user.userId} overrideFullName={nameWithCancellations} name={name} size={chipSize} tooltip={compact || tooltip} displayName={!compact} {...rest}/>
    }

  }
}
